/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': '正在装入...',
	'dlg_close': '关闭',
	'dlg_ok': '确定',
	'dlg_cancel': '取消',
	'dlg_back': '返回',
	'dlg_done': '完成',

	// Slider
	'sliderRegionLabel': '滑块控件，使用向右和向左箭头来移动滑块手柄',
	'sliderHandleLabel': '滑块手柄',
	'a11ySliderHandleLabel': '滑块手柄 %{sliderValue}',
	'sliderInputLabel': '值',

	// Side bar
	'sidebarAdd': '添加',
	'clearTextFilterValue': '清除',
	'missingDataSetData': '此数据集的数据不可用。请刷新此数据集，或联系管理员以获取对该源的访问权。',

	// Toolbar
	'toolbarRegionLabel': '工具栏',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': '字体系列',
	'fontSizeSelect': '字体大小',
	'fontColorSelect': '颜色',
	'fontStyle': '样式',
	'colorPickerTitle': '选择颜色',
	'bold': '粗体',
	'italic': '斜体',
	'underline': '下划线',
	'fontAlignment': '对齐',
	'justifyLeft': '左侧对齐',
	'justifyCenter': '居中对齐',
	'justifyRight': '右侧对齐',
	'insertOrderedList': '排序列表',
	'insertUnorderedList': '未排序列表',
	'fontColorPicker': '颜色选取器',
	'textWrap': '换行文本',
	'restore': '复原默认值',
	// Top Bottom
	'topbottomNumberOfResultsLabel': '结果数（%{lower} 到 %{higher}）',
	'topbottomPercentLabel': '百分比（%{lower}% 到 %{higher}%）',
	'topbottomSelectOption': '顶部或底部选项',
	'topbottomOptionLabel': '显示',
	'searchByLabel': '按',
	'searchNoMatches': '找不到任何匹配项',
	'topbottomRankColumnLabel': '将排名列添加到表中',
	'topbottomNone': '无',
	'topCount': '最高计数',
	'topPercent': '最高百分比',
	'bottomCount': '最低计数',
	'bottomPercent': '最低百分比',
	'searchColumn': '查找列',
	'searchColumnAriaLabel': '查找列。输入要搜索的列的名称，然后使用向下箭头在列表中查找该列',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': '排名 (%{columnLabel})',
	'topbottomClearLabel': '重置',

	// Format
	'formatAuto': '自动',
	'formatConvertPercent': '将小数转换为百分比',
	'formatAbbreviate': '缩写',
	'formatUseGrouping': '使用千位分隔符',
	'dateStyle': '日期样式',
	'dateTimeStyle': '日期/时间样式',
	'formatMissingValueCharactersInfo': '缺少值字符将指定在缺少值时要显示的字符。',
	'currencySymbolLabel': '货币符号',
	'customSymbolPlaceholder': '添加符号',
	'customSymbolLabelInfo': '指定一个或多个字符以用作定制符号。该符号将位于数字和任何符号之前。',
	'numberLabel': '数字标签',
	'numberPositionLabel': '标签位置',
	'numberLabelInfo': '为已设置格式的数字指定标签，并根据标签位置将其放置为前缀或后缀。',
	'nullValueDefault': '<默认>',
	'nullValueContent': '（无值）',
	'default': '默认',
	'beginning': '开始',
	'end': '结束',
	'formatLabel': '选择格式',

	// More data indicator
	'moreDataIndicator': '数据已在 %{threshold} 项处被剪切。应用过滤器以显示更少内容。',

	// Expanded View / Focus mode
	'evCollapse': '折叠',
	'duplicate': '重复',
	'copyOf': '%{name} 的副本',
	'unableToDuplicateBoard': '无法复制“%{name}”。',

	// Widget list
	'errorLoadingWidgetList': '无法装入对象。',

	// Custom widgets
	'customWidget': '自定义窗口小部件'
});
